const secureSessionTimeoutKey = 'secure_upload_session_timeout'

export function loginSecureUpload(token, memberData, sessionDurationSeconds, store) {
  if (!store) {
    return
  }
  // Only set session and timeout if sessionDurationSeconds is a valid number and > 0
  if (typeof sessionDurationSeconds === 'number' && !isNaN(sessionDurationSeconds) && sessionDurationSeconds > 0) {
    store.commit('globalComponents/setSecureMemberData', memberData)
    store.commit('globalComponents/setSessionExpiresAt', Date.now() + sessionDurationSeconds * 1000)
    store.commit('globalComponents/setIsSecureUploadLogin', true)
    store.commit('auth/setOtpType', 'email')
    clearSecureSessionTimeout()
    const timeout = setTimeout(() => {
      clearSecureSession(store)
      window.dispatchEvent(
        new CustomEvent('secure-upload-session-expired', {
          detail: {
            title: 'Session Expired',
            message: 'Your secure session has expired. Please log in again.',
          },
        })
      )
    }, sessionDurationSeconds * 1000)
    window.localStorage.setItem(secureSessionTimeoutKey, timeout)
  }
}

export function clearSecureSession(store) {
  if (!store) {
    return
  }
  store.commit('globalComponents/setSecureMemberData', null)
  store.commit('globalComponents/setIsSecureUploadLogin', false)
  store.commit('auth/setOtpType', null)
  clearSecureSessionTimeout()
}

function clearSecureSessionTimeout() {
  const timeoutId = window.localStorage.getItem(secureSessionTimeoutKey)
  if (timeoutId) {
    clearTimeout(Number(timeoutId))
    window.localStorage.removeItem(secureSessionTimeoutKey)
  }
}

export function isSecureUploadSessionActive() {
  // Check if session is active (can be expanded as needed)
  return !!window.localStorage.getItem(secureSessionTimeoutKey)
}

export function logoutSecureUpload(store) {
  clearSecureSession(store)
}

// Example file upload function
export async function uploadSecureFile(apiSecureClient, file) {
  try {
    // Implement actual upload logic here
    const response = await apiSecureClient.upload(file)
    return response?.success
  } catch (error) {
    return false
  }
}
